import React, { Component } from "react";
import history from "./../history";
import "../Center.css";
const rp = require("request-promise");

class TestnetEth extends Component {
  state = {
    userAddress: "",
    blackList: false
  };

  onSkip = async event => {
    history.push(`${process.env.PUBLIC_URL}/CustomToken`);
  };

  nextScreen = async event => {
    let response;
    try {
      response = await rp({
        method: "GET",
        uri: `https://faucet.ropsten.be/donate/${this.state.userAddress}`
      });
    } catch {
      console.log("Error getting tokens");
      const blackList = true;
      this.setState({
        blackList
      });
      return;
    }
    console.log("Response", response);
    history.push(`${process.env.PUBLIC_URL}/CustomToken`);
  };

  render() {
    console.log("Reciept", this.props.location.state.txHashRecipt);
    return (
      <div className="Start">
        <div className="lander">
          <form>
            <h1>Take a look at your wallet!</h1>
            <p>
              Once the transaction is approved, <br />
              open your wallet to see that all of your FRTs are <b>gone!</b>
            </p>
            <p>
              View your last transaction on <br />
              <a
                className="link-style"
                href={`https://ropsten.etherscan.io/tx/${this.props.location.state.txHashRecipt}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                Etherscan{" "}
              </a>
            </p>
            <p>
              You have approve 1 FRT swap, but as you can see <b>All</b> of your
              FRT are gone
            </p>
            <p></p>
          </form>
        </div>
      </div>
    );
  }
}

export default TestnetEth;
